import { useState } from "react";
import { z } from "zod";

import { AddressData } from "@/api/address/types";
import { useProfile } from "@/hooks/profile";

import { getValidation, transformAddress } from "./helper";

const AddressPickerFallback = ({ onChange }) => {
  const { data } = useProfile();

  const [address, setAddress] = useState<AddressData>({
    DIAddress: {},
    formattedAddress: transformAddress(data?.address),
  });

  const addressSchema = z.object({
    streetnumber: z.string().min(1),
    street: z.string().min(1),
    postalCode: z.string().min(4),
    city: z.string().min(1),
    floor_number: z.string().nullable().optional(),
    flat_number: z.string().nullable().optional(),
  });

  const handleChange = ({ target }, fieldName: string) => {
    if (
      getValidation(target.name) &&
      !getValidation(target.name)(target.value)
    ) {
      return false;
    }

    const updatedAddress = {
      DIAddress: {},
      formattedAddress: {
        ...address.formattedAddress,
        [fieldName]: target.value,
      },
    };

    setAddress(updatedAddress);

    try {
      addressSchema.parse(updatedAddress.formattedAddress);
      onChange(updatedAddress);
    } catch (_) {
      onChange(undefined);
    }
  };

  return (
    <div className="styles_container__2ZQ2Z ah-default-skin">
      <div className="ah-row">
        <div className="ah-col ah-col-3 noTopMargin yui-ac">
          <label htmlFor="street">Gate</label>
          <span className="inputWrapper">
            <input
              id="street"
              data-testid="street"
              name="street"
              onChange={(e) => handleChange(e, "street")}
              value={address.formattedAddress.street}
              type="text"
              className="streetInput yui-ac-input"
              autoComplete="off"
            />
          </span>
        </div>
        <div className="ah-col ah-col-1 noTopMargin yui-ac">
          <label htmlFor="number">Gatenr.</label>
          <span className="inputWrapper">
            <input
              id="number"
              data-testid="number"
              name="number"
              onChange={(e) => handleChange(e, "streetnumber")}
              value={address.formattedAddress.streetnumber}
              type="text"
              className="streetNumberInput yui-ac-input"
              autoComplete="off"
            />
          </span>
        </div>
      </div>
      <div className="ah-row">
        <div className="ah-col ah-col-1">
          <label htmlFor="floor_number">Etasje</label>
          <span className="inputWrapper">
            <input
              id="floor_number"
              data-testid="floor_number"
              name="floor_number"
              onChange={(e) => handleChange(e, "floor_number")}
              value={address.formattedAddress.floor_number}
              type="text"
              className="floorInput yui-ac-input"
              autoComplete="off"
            />
          </span>
        </div>
        <div className="ah-col ah-col-3">
          <label htmlFor="flat_number">Leilighet</label>
          <span className="inputWrapper">
            <input
              id="flat_number"
              data-testid="flat_number"
              name="flat_number"
              onChange={(e) => handleChange(e, "flat_number")}
              value={address.formattedAddress.flat_number}
              type="text"
              className="flatInput yui-ac-input"
              autoComplete="off"
            />
          </span>
        </div>
      </div>
      <div className="ah-row">
        <div className="ah-col ah-col-1">
          <label htmlFor="postcode">Postnr.</label>
          <input
            id="postcode"
            data-testid="postcode"
            name="postcode"
            onChange={(e) => handleChange(e, "postalCode")}
            value={address.formattedAddress.postalCode}
            type="text"
            className="zipLabel"
          />
        </div>
        <div className="ah-col ah-col-3">
          <label htmlFor="city">Poststed</label>
          <input
            id="city"
            data-testid="city"
            name="city"
            onChange={(e) => handleChange(e, "city")}
            value={address.formattedAddress.city}
            type="text"
            className="cityLabel"
          />
        </div>
      </div>
    </div>
  );
};

export default AddressPickerFallback;
